<template>
  <div class="washrooms-count">
    <div class="washroom-icon" :class="{'washroom-icon--large': large}">
      <img v-if="(washroom && washroom.facilityType == 'Male') || washroomType == 'Male'" src="/static/img/washroom--male.svg">
      <img v-if="(washroom && washroom.facilityType == 'Female') || washroomType == 'Female'" src="/static/img/washroom--female.svg">
      <img v-if="(washroom && washroom.facilityType == 'Disabled') || washroomType == 'Disabled'" src="/static/img/washroom--disabled.svg">
      <img v-if="(washroom && washroom.facilityType == 'BabyChanging') || washroomType == 'BabyChanging'" src="/static/img/washroom--baby-changing.svg">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'washroom-icon',

    props: ['washroom', 'washroom-type', 'large'],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {
    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .washrooms-count {
    .washroom-icon {
      display: inline-block;
      position: relative;

      img {
        width: 4rem;
      }

      &.washroom-icon--large {
        img {
          width: 5.5rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// WashroomIcon.vue?1cb6d056